<script lang="ts" setup>
import { NOOP } from "@vue/shared";
import { getActivePinia } from "pinia";
import { inject, onUnmounted, toRef } from "vue";
import { usePrescriptionStore } from "../../../../store/transitient/prescription";
import { parseRoute } from "../../../../utils/route";
import CreatePrescriptionForm from "../CreatePrescriptionForm";
import PrescriptionScreen from "../PrescriptionScreen";

const parsed = parseRoute(inject("drawer-url"));
const prescriptionId = parsed.id!;

// end

const props = defineProps<{
  openIssue?: boolean;

  contextId?: string;
  contextType?: string;
  success?: Function;
  showIssueLaterButton?: boolean;
  issueLaterLabel?: string;
  issueLaterColor?: string;
  hideIssueNow?: boolean;
  skipIssuing?: boolean;
}>();

defineEmits({
  success: () => true,
});
const setTitle = inject<(v: string) => void>("setTitle", NOOP);
setTitle("Prescribe Again");

// init
const store = usePrescriptionStore();
await store.initById(prescriptionId, "prescribe-again");

store.form.contextId =
  parsed.query.contextId ||
  (toRef(
    props,
    "contextId",
  ) as any) /* this type is correct, just typescript does not support this ATM*/;

store.form.contextType =
  parsed.query.contextType ||
  (toRef(
    props,
    "contextType",
  ) as any) /* this type is correct, just typescript does not support this ATM*/;

store.state.skipIssuing = parsed.query.skipIssuing || (toRef(props, "skipIssuing") as any);
store.form.action = "prescribe-again";

onUnmounted(() => {
  // clean store
  store.$dispose();

  // clear store state
  const pinia = getActivePinia();
  delete pinia!.state.value[store.$id];
});
// / init
</script>
<template>
  <PrescriptionScreen>
    <CreatePrescriptionForm
      form-url="/clinical/prescription/prescribe-again"
      hide-add-another
      :hide-issue-now="hideIssueNow"
      :show-issue-later-button="showIssueLaterButton"
      :issue-later-label="issueLaterLabel"
      :issue-later-color="issueLaterColor"
      @success="success"
    />
  </PrescriptionScreen>
</template>
